import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable } from 'components';
import { ClinicService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { LocationIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalAddress extends React.Component<Props> {

	state = {
		
	}
	
	render() {
		return (
			<div id="modal-users-address">
				<div className="row">
					<div className="col-12">
						<h3>Dirección</h3>
						<div className="container-establishments">
							<div className="item-establishment">
								<img src={ LocationIcon } />
								<div>
									<p>{ this.props.item?.address }</p>
									{
										this.props.item?.schedule_since && this.props.item?.schedule_until && (
											<p>
												<span>Horario:</span>
												{ this.props.item?.schedule_since }
												{ this.props.item?.schedule_since && this.props.item?.schedule_until ? ' - ' : '' }
												{ this.props.item?.schedule_until }
											</p>
										)
									}
								</div>
							</div>
						</div>
					</div>
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-12 text-center">
								<Button type="button" onClick={ () => this.props.onClose() }>
									Cerrar
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalAddress;